import { gql, useMutation } from '@apollo/client'

const mutation = gql`
  mutation DeletePost($groupPostId: String!) {
    deletePost(groupPostId: $groupPostId) {
      success
      message
    }
  }
`

export interface DeletePostInput {
  groupPostId: string
}

export interface DeletePostOutput {
  deletePost: {
    success: boolean
    message: string
  }
}

export const useDeletePost = () => useMutation<DeletePostOutput, DeletePostInput>(mutation)
